import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

@Pipe({
    name: 'loanEndDate',
    standalone: false
})
export class LoanEndDatePipe implements PipeTransform {
  transform(endDateStr?: string | null,status?: number): string {
    const now = dayjs();
    if (!endDateStr) return 'N/A';

    const endDate = dayjs(endDateStr);
    if (!endDate.isValid()) return 'N/A';

    const diffDays = endDate.diff(now, 'day');
    if (status == 2) {
      return endDate.format('DD/MM/YYYY');
    }

    const additionalLine = diffDays > 0 ? `\n(in ${diffDays} day${diffDays === 1 ? '' : 's'})` : '';
    return `${endDate.format('DD/MM/YYYY')}${additionalLine}`; 
  }
}